import React from "react"

export const withMobileImages = Component => ({ name = "MobileImages", image, loading, media }) => {
  Component.displayName = name
  return <Component image={image} loading={loading} media={media} />
}
